import React, { FunctionComponent } from 'react';
import Head from 'next/head';
import BarHeaderLayout from '@/pages/layouts/BarHeaderLayout';
import SignUpPage from '@/components/pageComponents/SignUpPage';
import packageStaticProps from '@/utility/nextJs/packageStaticProps';
import ProtectedPage from '@/components/navigation/ProtectedPage';
import { SignUpWizardContextProvider } from '@/contexts/SignUpWizardContext';

interface IProps {}

const SignUp: FunctionComponent<IProps> = () => (
  <BarHeaderLayout>
    <Head>
      <title>Moment - Sign Up</title>
    </Head>
    <ProtectedPage type="lax">
      <SignUpWizardContextProvider>
        <SignUpPage />
      </SignUpWizardContextProvider>
    </ProtectedPage>
  </BarHeaderLayout>
);

export async function getStaticProps() {
  return packageStaticProps({});
}

export default SignUp;
